import { render, staticRenderFns } from "./cadastro-icon.vue?vue&type=template&id=6c6e1593&"
import script from "./cadastro-icon.vue?vue&type=script&lang=js&"
export * from "./cadastro-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports